import React from 'react';
import { Instagram, Facebook, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#070707] border-t border-white/5 px-6 lg:px-12 py-16">
      <div className="max-w-[1500px] mx-auto">
        <div className="grid md:grid-cols-4 gap-10 mb-14">
          <div className="md:col-span-2">
            <div className="flex items-center gap-1 mb-5">
              <img
                src="/dm-logo.png"
                alt="Dion Magee Events & Weddings"
                className="w-20 h-20 object-contain"
              />
              <div className="leading-none">
                <div className="text-white font-serif text-[26px] tracking-[0.18em] leading-none">
                  DION MAGEE
                </div>
                <div className="text-[#c9a96e]/90 text-[11px] tracking-[0.32em] mt-1 leading-none">
                  EVENTS &amp; WEDDINGS
                </div>
              </div>
            </div>
            <p className="text-white/55 text-sm leading-[1.9] max-w-md font-light">
              An atelier devoted to producing cinematic weddings and milestone celebrations for discerning families across the United States and select destinations worldwide.
            </p>
          </div>

          <div>
            <div className="text-[#c9a96e] text-[10px] tracking-[0.4em] uppercase mb-5">Navigate</div>
            <ul className="space-y-3 text-white/70 text-sm font-light">
              <li><a href="#services" className="hover:text-[#c9a96e] transition-colors">Services</a></li>
              <li><a href="#portfolio" className="hover:text-[#c9a96e] transition-colors">Portfolio</a></li>
              <li><a href="#about" className="hover:text-[#c9a96e] transition-colors">About</a></li>
              <li><a href="#testimonials" className="hover:text-[#c9a96e] transition-colors">Testimonials</a></li>
              <li><a href="#contact" className="hover:text-[#c9a96e] transition-colors">Contact</a></li>
            </ul>
          </div>

          <div>
            <div className="text-[#c9a96e] text-[10px] tracking-[0.4em] uppercase mb-5">Follow</div>
            <div className="flex gap-3">
              {[
                { Icon: Instagram, href: '#', label: 'Instagram', external: false },
                {
                  Icon: Facebook,
                  href: 'https://www.facebook.com/dionmageeevents/',
                  label: 'Facebook',
                  external: true,
                },
                { Icon: Linkedin, href: '#', label: 'LinkedIn', external: false },
              ].map(({ Icon, href, label, external }) => (
                <a
                  key={label}
                  href={href}
                  target={external ? '_blank' : undefined}
                  rel={external ? 'noopener noreferrer' : undefined}
                  aria-label={label}
                  className="w-10 h-10 border border-white/15 hover:border-[#c9a96e] hover:text-[#c9a96e] text-white/60 flex items-center justify-center transition-colors"
                >
                  <Icon size={14} strokeWidth={1.5} />
                </a>
              ))}
            </div>
            <div className="text-[#c9a96e]/70 text-[10px] tracking-[0.35em] uppercase mt-8">
              Est. 1999
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row gap-4 justify-between items-center">
          <div className="text-white/40 text-xs tracking-wider">
            © {new Date().getFullYear()} Dion Magee Events &amp; Weddings. All rights reserved.
          </div>
          <div className="flex gap-8 text-white/40 text-[10px] tracking-[0.3em] uppercase">
            <a href="#" className="hover:text-[#c9a96e] transition-colors">Privacy</a>
            <a href="#" className="hover:text-[#c9a96e] transition-colors">Terms</a>
            <a href="#" className="hover:text-[#c9a96e] transition-colors">Press</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
